import type { ListNotificationsParams } from '@/modules/notifications/types';

export const notificationQueryKeys = {
    all:   ['notifications'] as const,
    lists: () => [...notificationQueryKeys.all, 'list'] as const,
    list:  (params: ListNotificationsParams = {}) => [...notificationQueryKeys.lists(), params] as const,
} as const;
